export default {
  getTagList: (state) => state.tagList,
  getEngagementTypeId: (state) => state.engagementTypeId,
  getIsDev: (state) => state.isDev,
  getTimezone: (state) => state.timezone,
  getEngagement: (state) => state.engagement,
  getTagArray: (state) => state.tagArray,
  getEngagementParameters: (state) => state.engagementParameters,
  getIsRfmEnabled: (state) => state.isRfmEnabled,
  getCountTotalCustomers: (state) => state.countTotalCustomers,
  getCountAudienceCustomers: (state) => state.countAudienceCustomers,
  getIsLoading: (state) => state.isLoading,
  getCustomerCustomList: (state) => state.customerCustomList,
  getCustomAudienceBrowserLangaugeList: (state) => state.customAudienceBrowserLangaugeList,
  getCustomAudienceCityList: (state) => state.customAudienceCityList,
  getCustomAudienceCountryList: (state) => state.customAudienceCountryList,
  getCustomAudienceFirstNameList: (state) => state.customAudienceFirstNameList,
  getCustomFieldsAudience: (state) => state.customFieldsAudience,
  getCancelToken: (state) => state.cancelToken,
};
